const daysOfWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export default function dateField({ dayOfMonth, month, year }) {
  return {
    dayOfMonth,
    month,
    year,
    dayOfWeek: null,

    value: null,

    init() {
      this.setDateFromSelectedValues();
    },

    setDateFromSelectedValues() {
      this.value = new Date(Date.UTC(this.year, this.month - 1, this.dayOfMonth));
      this.dayOfWeek = daysOfWeek[this.value.getUTCDay()];
    },

    setSelectedValuesFromDate() {
      this.year = this.value.getUTCFullYear();
      this.month = this.value.getUTCMonth() + 1;
      this.dayOfMonth = this.value.getUTCDate();
      this.dayOfWeek = daysOfWeek[this.value.getUTCDay()];
    },

    incrementDate(delta) {
      this.dayOfMonth += delta;
      this.handleChange();
    },

    handleChange() {
      this.setDateFromSelectedValues();
      this.setSelectedValuesFromDate();
    },
  };
}
